import React from 'react';
import { motion } from 'framer-motion';
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaNodeJs, FaDatabase, FaAws, FaDocker, FaWordpress, FaShopify, FaPython, FaJava, FaPlug, FaBoxOpen, FaServer, FaSlack, FaJira, FaTools, FaCode, FaShieldAlt, FaNetworkWired } from 'react-icons/fa';
import { SiTailwindcss, SiBootstrap, SiMongodb, SiDjango, SiVisualstudiocode, SiGithub, SiCanva, SiPostman, SiGooglecloud, SiVultr, SiFastapi, SiNextdotjs } from 'react-icons/si';

const skillCategories = [
  {
    title: "Frontend",
    skills: [
      { icon: <FaHtml5 />, name: "HTML" },
      { icon: <FaCss3Alt />, name: "CSS" },
      { icon: <FaJs />, name: "JavaScript" },
      { icon: <FaReact />, name: "React.js" },
      { icon: <SiNextdotjs />, name: "Next.js" },
      { icon: <SiTailwindcss />, name: "Tailwind CSS" },
      { icon: <SiBootstrap />, name: "Bootstrap" }
    ]
  },
  {
    title: "Backend",
    skills: [
      { icon: <FaNodeJs />, name: "Node.js" },
      { icon: <FaServer />, name: "Express.js" },
      { icon: <SiDjango />, name: "Django" },
      { icon: <SiFastapi />, name: "FastAPI" },
      { icon: <FaPython />, name: "Python" },
      { icon: <FaJava />, name: "Java" }
    ]
  },
  {
    title: "Database",
    skills: [
      { icon: <SiMongodb />, name: "MongoDB" },
      { icon: <FaDatabase />, name: "SQL" },
      { icon: <FaDatabase />, name: "SQLite" },
      { icon: <FaDatabase />, name: "PostgreSQL" }
    ]
  },
  {
    title: "Cloud & DevOps",
    skills: [
      { icon: <FaAws />, name: "AWS" },
      { icon: <SiGooglecloud />, name: "Google Cloud" },
      { icon: <FaDocker />, name: "Docker" },
      { icon: <SiVultr />, name: "VPS Server" },
      { icon: <FaNetworkWired />, name: "DNS Management" }
    ]
  },
  {
    title: "Tools & Platforms",
    skills: [
      { icon: <SiGithub />, name: "GitHub" },
      { icon: <SiPostman />, name: "Postman" },
      { icon: <SiVisualstudiocode />, name: "VS Code" },
      { icon: <FaWordpress />, name: "WordPress" },
      { icon: <FaShopify />, name: "Shopify" },
      { icon: <FaSlack />, name: "Slack" },
      { icon: <FaJira />, name: "Jira" },
      { icon: <SiCanva />, name: "Canva" }
    ]
  },
  {
    title: "Concepts & Practices",
    skills: [
      { icon: <FaPlug />, name: "API Integrations" },
      { icon: <FaBoxOpen />, name: "Package Development" },
      { icon: <FaTools />, name: "Unit Testing" },
      { icon: <FaCode />, name: "Data Structures & Algorithms" },
      { icon: <FaShieldAlt />, name: "Object-Oriented Programming" }
    ]
  }
];

function Skills() {
  return (
    <section className="skills">
      <motion.div 
        initial={{ y: 200, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2>Skills</h2>
        <p className="skills-description">Technologies and tools I work with</p>
        <div className="skills-container">
          {skillCategories.map((category, categoryIndex) => (
            <motion.div
              key={category.title}
              className="skill-category"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: categoryIndex * 0.1 }}
            >
              <h3 className="category-title">{category.title}</h3>
              <div className="skills-grid">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <span className="skill-icon">{skill.icon}</span>
                    <span className="skill-name">{skill.name}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}

export default Skills;
